/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Upload_FormatInputs */

const cs_pm_upload_format = /** @type {(inputs: Pm_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloupce: external_id (povinné), rkid, title, url, price, area, rooms, city, street, lat, lon, photos.`)
};

const en_pm_upload_format = /** @type {(inputs: Pm_Upload_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Columns: external_id (required), rkid, title, url, price, area, rooms, city, street, lat, lon, photos.`)
};

/**
* | output |
* | --- |
* | "Columns: external_id (required), rkid, title, url, price, area, rooms, city, street, lat, lon, photos." |
*
* @param {Pm_Upload_FormatInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_upload_format = /** @type {((inputs?: Pm_Upload_FormatInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Upload_FormatInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_upload_format(inputs)
	return cs_pm_upload_format(inputs)
});